import React from "react";
import CommonService from "@services/CommonService";

const ChannelList = ({ channels, onChannelClick, channelColumnCount, channelAlignment, isMobile }) => {
    const getJustifyContent = () => {
        if (isMobile) {
            return "center";
        }
        const alignment = channelAlignment?.toLowerCase();
        if (alignment === "center aligned") return "center";
        if (alignment === "right aligned") return "flex-end";
        return "flex-start";
    };
    return (
        <div
            className="norstella-pf-grid-wrapper"
            part="cfgridWrapperPatientChannel"
            style={{ justifyContent: getJustifyContent() }}
        >
            <div
                className="norstella-pf-grid-channel"
                style={{ gridTemplateColumns: `repeat(${isMobile ? 1 : channelColumnCount}, 1fr)`}}
            >
                {channels.map((channel, index) => (
                    <div
                        key={index}
                        className={`norstella-pf-channel channel-${CommonService.getSafeAlphaNumericText(channel.channelName)}`}
                        onClick={() => onChannelClick(channel)}
                    >
                        {channel.channelName}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChannelList;
